import { render, staticRenderFns } from "./DataListStaffs_rejete.vue?vue&type=template&id=552dc508&scoped=true&"
import script from "./DataListStaffs_rejete.vue?vue&type=script&lang=js&"
export * from "./DataListStaffs_rejete.vue?vue&type=script&lang=js&"
import style0 from "./DataListStaffs_rejete.vue?vue&type=style&index=0&id=552dc508&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552dc508",
  null
  
)

export default component.exports